import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { links } from './links';
import useCountUp from './useCountUp';

const Check = () => (
  <svg fill="currentColor" viewBox="0 0 20 20" aria-hidden>
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
  </svg>
);
// Ball-by-ball chips drop in one after another, looping — feels live.
const BALLS = [
  { v: '1', t: 'run' },
  { v: '4', t: 'four' },
  { v: '6', t: 'six' },
  { v: 'W', t: 'wkt' },
  { v: '2', t: 'run' },
  { v: '4', t: 'four' },
];
const COMMENTARY = [
  'FOUR! Driven through the covers',
  'SIX! Launched over long-on',
  'OUT! Caught at deep midwicket',
  'Quick single, good running',
];

const LiveCard = () => {
  const [runRef, runs] = useCountUp(187, { duration: 1700, start: 150, immediate: true });
  const [shown, setShown] = useState(0);
  const [line, setLine] = useState(0);

  // Stagger balls in, then cycle commentary.
  useEffect(() => {
    const timers = BALLS.map((_, i) => setTimeout(() => setShown(i + 1), 500 + i * 260));
    return () => timers.forEach(clearTimeout);
  }, []);
  useEffect(() => {
    const id = setInterval(() => setLine((l) => (l + 1) % COMMENTARY.length), 2600);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="cf-card" ref={runRef}>
      <div className="cf-card__bar">
        <span className="cf-card__live"><i />LIVE</span>
        <span className="cf-card__chip cf-card__chip--on">T20</span>
        <span className="cf-card__chip">My Matches</span>
      </div>

      <div className="cf-card__team">
        <div className="cf-card__side">
          <span className="cf-card__crest cf-card__crest--a">RR</span>
          <div className="cf-card__meta">
            <span className="cf-card__name">Royal Risers</span>
            <span className="cf-card__sub">Batting · 18.2 ov</span>
          </div>
        </div>
        <div className="cf-card__score">{runs}<small>/4</small></div>
      </div>

      <div className="cf-card__progress"><span style={{ width: '91%' }} /></div>

      <div className="cf-card__team">
        <div className="cf-card__side">
          <span className="cf-card__crest cf-card__crest--b">SW</span>
          <div className="cf-card__meta">
            <span className="cf-card__name">Street Warriors</span>
            <span className="cf-card__sub">Target 188 · 10 to win</span>
          </div>
        </div>
        <div className="cf-card__score cf-card__score--muted">—</div>
      </div>

      <div className="cf-card__balls">
        <span className="cf-card__balls-label">This over</span>
        <div className="cf-card__chips">
          {BALLS.map((b, i) => (
            <span key={i} className={`cf-ball cf-ball--${b.t}${i < shown ? ' is-in' : ''}`}>{b.v}</span>
          ))}
        </div>
      </div>

      <div className="cf-card__commentary">
        <span className="cf-card__dot" />
        <span key={line} className="cf-card__comm-text">{COMMENTARY[line]}</span>
      </div>
    </div>
  );
};

const Hero = () => {
  return (
    <section className="cf-hero">
      <div className="cf-hero__bg" aria-hidden>
        <div className="cf-hero__orb" />
        <div className="cf-hero__grid" />
      </div>

      <div className="cf-hero__content cf-container">
        <div className="cf-hero__inner">
          <div className="cf-badge">
            <span className="cf-badge__dot" />
            <span>100% free · no ads</span>
          </div>

          <h1 className="cf-hero__title">
            Your cricket,<br />
            <span className="cf-text-gradient">leveled up.</span>
          </h1>

          <p className="cf-hero__subtitle">
            Live scoring, real stats &amp; local team challenges — in one app.
          </p>

          <LiveCard />

          <div className="cf-hero__ctas">
            <Link to={links.login} className="cf-btn-primary cf-btn-block">Start for Free</Link>
            <Link to={links.startMatch} className="cf-btn-secondary cf-btn-block">
              <svg className="cf-icon-sm" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden>
                <path strokeLinecap="round" strokeLinejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Start a Match
            </Link>
          </div>

          <div className="cf-hero__trust">
            <span className="cf-hero__trust-item"><Check />Free forever</span>
            <span className="cf-hero__trust-item"><Check />Setup in 2 min</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
